import React from "react";
import { useSelector } from "react-redux";
import useCustomHistory from "@/hooks/useCustomHistory";
import { useTranslation } from "react-i18next";
import { Wrapper, AntSyncOutlined, AntButton } from "./styles";
import { Tooltip, Typography, notification } from "antd";
import { SYNC_ALLOWED_EMAILS } from "@/utils/constants/constants";
import { syncSurveyData } from "@/apis/surveyAPI";
const Caption = () => {
  const { t } = useTranslation();
  const { refreshHistory } = useCustomHistory();
  const user = useSelector((state) => state.authentication.authenticatedUser);

  const handleRefresh = () => {
    refreshHistory();
  };

  const openNotification = (msg) => {
    notification.open({
      message: msg,
      duration: 5,
    });
  };

  const handleSyncClick = () => {
    // Add your sync logic here
    syncSurveyData()
      .then((res) => {
        console.log("res: ", res);
        openNotification(res?.data?.message);
      })
      .catch((error) => {
        console.error("Sync error: ", error);
        openNotification(
          error?.errorCode?.error || "An error occurred while syncing data"
        );
      });
  };

  return (
    <Wrapper>
      <Wrapper>
        {t("components.survey.header")}
        <AntSyncOutlined onClick={handleRefresh} />
      </Wrapper>

      {SYNC_ALLOWED_EMAILS.includes(user?.emailAddress) && (
        <Tooltip title="This will sync the survey related data with the latest data from the MongoDB.">
          <AntButton onClick={() => handleSyncClick()}>
            <Typography>Sync Data</Typography>
          </AntButton>
        </Tooltip>
      )}
    </Wrapper>
  );
};

export default Caption;
